module.exports = __webpack_public_path__ + "img/usa-digestive-diseases-male.947c725a.png";